module.exports = __webpack_public_path__ + "static/media/Unirac_White.c07e66f4.png";